import React from 'react';

import AddRoleForm from './AddRoleForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRestrictedActionShowState, useRestrictedActionShowActions } from './RestrictedActionShowContext';

import styles from './RestrictedActionModal.module.scss';

const AddRoleModal = ({ restrictedAction }) => {
  const state = useRestrictedActionShowState();
  const { closeAddRoleModal } = useRestrictedActionShowActions();

  return (
    <StandardModal
      isOpen={state?.addRoleModalIsOpen}
      onRequestClose={() => {
        closeAddRoleModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Add Role to Restricted Action
        </h2>
        <AddRoleForm restrictedAction={restrictedAction} />
      </section>
    </StandardModal>
  );
};

export default AddRoleModal;
